import { MenuDesignTokens } from '@primeuix/themes/types/menu';

export const menu: MenuDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        background: '{blue.500}',
      },
      list: {
        gap: '8px',
        padding: '0',
      },
      item: {
        focusBackground: '{blue.500}',
        icon: {
          color: '{primary.500}',
          focusColor: '{primary.500}',
        },
      },
      submenuLabel: {
        color: '{primary.500}',
        fontWeight: '600',
      },
    },
  },
};
